"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSetupIntentDataToPayload = exports.createPaymentIntentDataToPayload = exports.stripeEnvHeader = exports.endpoint = void 0;
const payments_widget_utils_1 = require("@snap-mobile/payments-widget-utils");
const config_1 = __importDefault(require("./config"));
exports.endpoint = config_1.default.paymentsApiUrl;
function stripeEnvHeader(opts, others = {}) {
    const headers = Object.assign({}, others.headers ?? {}, {
        'Content-Type': 'application/json',
        'X-Stripe-Environment': opts?.stripeEnvironment ?? payments_widget_utils_1.StripeEnvironment.RAISE,
    });
    return Object.assign({}, others, {
        headers,
    });
}
exports.stripeEnvHeader = stripeEnvHeader;
function createPaymentIntentDataToPayload(data) {
    const { customer, destination, description, finalDestination, externalPaymentId, idempotencyKey, metadata, paymentMethod, permittedPaymentMethods, snapAmount, statementDescriptorSuffix, totalAmount, } = data;
    const resp = {
        amount: totalAmount,
        application_fee_amount: snapAmount,
        customer: customer || undefined,
        description,
        externalPaymentId,
        idempotencyKey,
        metadata: metadata,
        on_behalf_of: destination,
        payment_method: paymentMethod || undefined,
        statement_descriptor_suffix: statementDescriptorSuffix ?? undefined,
        transfer_data: { destination: destination },
    };
    if (permittedPaymentMethods && permittedPaymentMethods.length > 0) {
        resp.payment_method_types = permittedPaymentMethods;
    }
    else {
        resp.automatic_payment_methods = { enabled: true };
    }
    if (finalDestination) {
        resp.metadata = { ...resp.metadata, finalDestination };
    }
    return resp;
}
exports.createPaymentIntentDataToPayload = createPaymentIntentDataToPayload;
function createSetupIntentDataToPayload({ customer, destination, description, finalDestination, externalPaymentId, idempotencyKey, metadata, paymentMethod, permittedPaymentMethods, }) {
    const resp = {
        customer: customer || undefined,
        description,
        externalPaymentId,
        idempotencyKey,
        metadata,
        on_behalf_of: destination,
        payment_method: paymentMethod || undefined,
    };
    if (permittedPaymentMethods && permittedPaymentMethods.length > 0) {
        resp.payment_method_types = permittedPaymentMethods;
    }
    else {
        resp.automatic_payment_methods = { enabled: true };
    }
    if (finalDestination) {
        resp.metadata = { ...resp.metadata, finalDestination };
    }
    return resp;
}
exports.createSetupIntentDataToPayload = createSetupIntentDataToPayload;
